import type { BestNextMoveBundle } from '../contracts/types'

export const BNM_ORBIS: BestNextMoveBundle = {
  generatedAt: '2026-05-31T00:00:00.000Z',
  primary: {
    recommendationId: 'bnm-orbis-structure-01',
    category: 'improve_structure',
    title: 'Align story structure before timeline or presentation',
    summary:
      'Finish grounding scene flow so OmniStudio, OmniCast, and Scape pathways stay coherent.',
    whyThisMatters:
      'Clear structure lets SynkTribe translate work into timeline, controlled presentation, Scape, and XR without fragmenting the signal.',
    riskIfIgnored:
      'Later handoffs may need rework; presentation and Scape layers will lack a stable spine.',
    suggestedSurface: 'guided_studio',
    suggestedAction: 'Continue shaping structure in Guided Studio',
    suggestedStageId: 'structure_coherent',
    affectedProjectId: 'orbis',
    priority: 'high',
    confidence: 'high',
    humanConfirmationRequired: false,
    allowedActions: ['start', 'defer', 'dismiss'],
    forbiddenActions: [
      'auto_execute',
      'auto_publish',
      'auto_handoff',
      'auto_advance_stage',
      'sign_in',
      'create_account',
      'launch_app',
    ],
    toolAvailabilityRequired: 'guided_studio',
    blockersAddressed: [],
  },
  secondary: [
    {
      recommendationId: 'bnm-orbis-rights-01',
      category: 'protect_rights',
      title: 'Review Rights Passport status',
      summary:
        'Rights review is pending before controlled presentation or external witness.',
      whyThisMatters:
        'Presentation and witness surfaces require clear ownership and consent boundaries.',
      riskIfIgnored:
        'Pitch, screening, or showcase paths may be blocked or require rework.',
      suggestedSurface: 'rights_passport',
      suggestedAction: 'Review rights status',
      suggestedStageId: 'rights_passport_pending',
      affectedProjectId: 'orbis',
      priority: 'medium',
      confidence: 'high',
      humanConfirmationRequired: true,
      allowedActions: ['review', 'defer', 'dismiss'],
      forbiddenActions: ['auto_publish', 'auto_approve_rights'],
      toolAvailabilityRequired: 'rights_passport',
      blockersAddressed: [],
    },
    {
      recommendationId: 'bnm-orbis-pathway-01',
      category: 'pathway_education',
      title: 'Path ahead: presentation → Scape → XR',
      summary:
        'OmniCast, Scapes / Worlds, and XR remain future pathways — statuses stay visible on Project Progress.',
      whyThisMatters:
        'Understanding the arc prevents overpromising runtime that is not yet available.',
      riskIfIgnored: 'Low — informational only.',
      suggestedSurface: 'none',
      suggestedAction: 'View Project Progress',
      affectedProjectId: 'orbis',
      priority: 'low',
      confidence: 'high',
      humanConfirmationRequired: false,
      allowedActions: ['dismiss'],
      forbiddenActions: ['auto_execute', 'auto_publish'],
      blockersAddressed: [],
    },
  ],
}
